import PageHeader from "@/components/PageHeader";
import Marquee from "@/components/Marquee";
import { Reveal, SectionHeading } from "@/components/motion";

export default function AboutPage() {
  return (
    <div data-testid="about-page">
      <PageHeader
        kicker="About"
        title="Built in Montrose, Colorado"
        sub="Outdoor Display Products LLC designs and manufactures The Banner Bar — a patented outdoor banner frame system born from watching too many good banners die young."
        image="/assets/img/w-about-header-1273.webp"
        imagePosition="object-top"
      />
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-12 lg:py-24">
        <div className="grid items-start gap-12 lg:grid-cols-2">
          <div>
            <SectionHeading kicker="Our Mission" title="Make every banner outlast its campaign" />
            <Reveal i={2}>
              <div className="mt-6 space-y-4 text-sm leading-relaxed text-slate-400 md:text-base" data-testid="about-mission">
                <p>Outdoor banner advertising has a dirty secret: most freestanding banners are hung with rope between two posts, and the wind destroys them. Posts fold inward, vinyl sags, hems shred — and the business's message collapses with it.</p>
                <p>The Banner Bar (U.S. Patent 10,410,553 B2) solves the physics instead of fighting it. A telescoping aluminum bar locks the posts apart so the frame cannot collapse under wind load, while precision-sized bungees hold tension with engineered give.</p>
                <p>We manufacture in the USA and sell direct, through stocking sign shops, and through wholesale partners across the country — from single storefronts to national franchise rollouts.</p>
              </div>
            </Reveal>
          </div>
          <Reveal i={1}>
            <div className="space-y-4">
              <div className="clip-corner overflow-hidden border border-girder">
                <img src="/assets/img/w-about-odp-sdi0685.jpg" alt="Banner Bar installation at a Chevrolet dealership" className="aspect-[4/3] w-full object-cover" />
              </div>
              <div className="grid grid-cols-3 gap-px border border-girder bg-girder" data-testid="about-facts">
                {[["PATENT", "10,410,553 B2"], ["ORIGIN", "MADE IN USA"], ["HQ", "MONTROSE, CO"]].map(([k, v]) => (
                  <div key={k} className="bg-obsidian px-4 py-4 text-center">
                    <p className="font-mono text-[10px] uppercase tracking-widest text-slate-500">{k}</p>
                    <p className="mt-1 font-display text-sm font-bold uppercase text-slate-100">{v}</p>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="border-t border-girder bg-steel/40 py-20 lg:py-24" data-testid="about-audiences">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
          <SectionHeading kicker="Who We Build For" title="Three customers. One standard." />
          <div className="mt-12 grid gap-6 md:grid-cols-3">
            {[
              { t: "Sign Shops", d: "Dealer pricing, fast reorders, and a product that turns every banner sale into a profitable install service." },
              { t: "Corporate Brands", d: "Uniform, professional displays across every franchise location — with kits drop-shipped to each store." },
              { t: "Local Business", d: "A 15-minute self-installed frame that keeps your curbside message standing in real weather." },
            ].map((c, i) => (
              <Reveal key={c.t} i={i} className="clip-corner border border-girder bg-obsidian/60 p-8">
                <span className="font-display text-5xl font-black text-outline">0{i + 1}</span>
                <h3 className="mt-4 font-display text-2xl font-bold uppercase text-slate-100">{c.t}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">{c.d}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <Marquee />
    </div>
  );
}
